import UsersIcon from '@mui/icons-material/People';

import UsersList from './UsersList';
import UserEdit from './UserEdit';
import UserCreate from './UserCreate';

export default {
    list: UsersList,
    edit: UserEdit,
    create: UserCreate,
    icon: UsersIcon,
};
